import { Briefcase, Calendar, Edit3, LoaderCircle, Trash2, User } from "lucide-react";
import { Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import i18n from "../../../i18n";

const statusVariantMap = {
  active: "success",
  inactive: "secondary",
  ended: "warning",
  archived: "dark",
};

const formatDate = (value) => {
  if (!value) {
    return i18n.t("components.ProjectMemberItem.present");
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return i18n.t("components.ProjectMemberItem.present");
  }

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  }).format(parsed);
};

const getInitials = (name) => {
  if (!name) {
    return "?";
  }

  const parts = name.split(" ").filter(Boolean);
  if (!parts.length) {
    return "?";
  }

  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }

  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

const ProjectMemberItem = ({ member, onEdit, onRemove, isRemoving = false }) => {
  const fullName =
    `${member?.user?.first_name || ""} ${member?.user?.last_name || ""}`.trim() ||
    member?.label ||
    i18n.t("components.ProjectMemberItem.unknown_member");

  const role = member?.role || i18n.t("components.ProjectMemberItem.no_role_assigned");
  const statusKey = String(member?.status || i18n.t("components.ProjectMemberItem.inactive")).toLowerCase();
  const avatarUrl = member?.user?.profile_picture_url || member?.profile_picture_url || "";

  return (
    <article className="project-member-card">
      <div className="project-member-avatar-wrap">
        {avatarUrl ? (
          <img src={avatarUrl} alt={fullName} className="project-member-avatar" />
        ) : (
          <div className="project-member-avatar project-member-avatar-fallback">{getInitials(fullName)}</div>
        )}
      </div>

      <div className="project-member-main">
        <h6 className="mb-1">{fullName}</h6>
        <p className="mb-1 text-muted d-flex align-items-center gap-2">
          <Briefcase size={12} />
          <span>{role}</span>
        </p>
        <p className="mb-0 text-muted d-flex align-items-center gap-2">
          <Calendar size={12} />
          <span>
            {formatDate(member?.start_date)} - {formatDate(member?.end_date)}
          </span>
        </p>
      </div>

      <div className="project-member-meta">
        <Badge bg={statusVariantMap[statusKey] || "secondary"}>{member?.status || "Inactive"}</Badge>
        <div className="project-member-etis">{member?.monthly_etis || 0} ETIs</div>
      </div>

      <div className="project-member-actions">
        <OverlayTrigger placement="top" overlay={<Tooltip>{i18n.t("components.ProjectMemberItem.edit_member_allocation")}</Tooltip>}>
          <Button variant="light" className="" onClick={() => onEdit(member)}>
            <Edit3 size={14} />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger placement="top" overlay={<Tooltip>{i18n.t("components.ProjectMemberItem.remove_member")}</Tooltip>}>
          <Button
            variant="light"
            className="text-danger"
            onClick={() => onRemove(member)}
            disabled={isRemoving}
          >
            {isRemoving ? <LoaderCircle size={14} className="spin" /> : <Trash2 size={14} />}
          </Button>
        </OverlayTrigger>
      </div>

      <div className="project-member-mobile-status">
        <User size={12} />
      </div>
    </article>
  );
};

export default ProjectMemberItem;
